import { useNavigate } from "react-router-dom";
import Button from "../../../Button/Button";
import { S } from "./Instructions.styled";

interface InstructionsProps {
  text: string;
  toTheNextStep?: () => void;
  isOfflineApplication: boolean;
}

export const Instructions = ({
  text,
  toTheNextStep,
  isOfflineApplication,
}: InstructionsProps) => {
  const navigate = useNavigate();

  return (
    <S.Container isCustomStyle={isOfflineApplication}>
      <S.Instruction
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
      {!isOfflineApplication ? (
        <Button onClick={toTheNextStep} isBlock>
          Continue
        </Button>
      ) : (
        <Button
          isBlock
          borderColor="color-white"
          backgroundColor="color-white"
          withShadow
          textColor="button"
          size="l"
          onClick={() => {
            window.open(window.location.origin);

          }}
        >
          Back to Homepage
        </Button>
      )}
    </S.Container>
  );
};
